<template>
    <QNavigation size="middle" v-bind="navigationConfig" @click="onNavClick" :scrollTarget="scrollTarget" @change="onNavChange">
        <template v-for="(_, name) in slots" #[name]="slotProps">
            <slot :name="name" v-bind="slotProps" />
        </template>
    </QNavigation>
</template>
<script lang="ts" setup>
import { ref, onMounted, watch, useSlots } from 'vue';
import { QNavigation } from '@q-front-npm/h5-ui';
import { useStoreCommon } from '../../store/common';
import { assign } from 'radash';
import { getNavHeight, setWebviewConfig, closeWebview, jsbStorage } from '@q-front-npm/jsbridge';
import { useWindowResize } from '../../hooks';
const storeCommon = useStoreCommon();
const slots = useSlots();
const props = withDefaults(
    defineProps<{
        config?: Record<string, any>;
        isCloseWebiew?: boolean;
        scrollTarget?: HTMLElement;
    }>(),
    {
        config: () => ({}),
        isCloseWebiew: true,
    }
);

const defaultConfig = {
    statusHeight: '36',
    fullScreen: true,
    maxWidth: storeCommon.adaptFullScreen ? 'auto' : `${Math.round(storeCommon.appMaxWidth)}`,
    navPadding: 16,
    size: 'middle',
    menuConfig: {
        left: [
            {
                icon: '&#xe660;',
                type: 'back',
                title: '',
                data: {},
            }
        ],
        right: [],
    },
    styleConfig: {
        default: {
            bg: {
                background: 'transparent',
            },
        },
        fixed: {
            bg: {
                background: 'transparent',
            },
        },
    },
};
const navigationConfig = ref<Record<string, any>>(assign(defaultConfig, props.config));

const onUpdate = (config: Record<string, any>) => {
    navigationConfig.value = assign(navigationConfig.value, config);
};

const getStatusBarInfo = async() => {
    if (import.meta.env.VITE_ENV === 'dev') {
        onUpdate({
            statusHeight: storeCommon.inSidePanel ? 0 : '20',
        });
        storeCommon.headerHeight = storeCommon.inSidePanel ? 52 : 72;
        emit('initFinish');
        return;
    }
    const statusBarHKey = storeCommon.inSidePanel ? 'statusBarHInSidePanel' : 'statusBarH';
    let statusBarH = await jsbStorage.get(statusBarHKey, 'activityCommon');
    // 存在缓存先更新数据，再获取覆盖
    if (statusBarH) {
        onUpdate({
            statusHeight: statusBarH,
        });
        storeCommon.headerHeight = +statusBarH + 52;
        storeCommon.statusBarHeight = +statusBarH;
    }
    const navConfig = await getNavHeight();
    console.log('-- navConfig', navConfig);
    statusBarH = navConfig.statusBarH || 36;
    jsbStorage.set(statusBarHKey, statusBarH, 'activityCommon');
    onUpdate({
        statusHeight: statusBarH,
    });
    storeCommon.headerHeight = +statusBarH + 52;
    storeCommon.statusBarHeight = +statusBarH;
    setWebviewConfig({ status_bar: navigationConfig.value.styleConfig.default.statusBar, });
    emit('initFinish');
};

// 如果使用侧面板，则需要监听窗口大小变化 防止折叠屏从侧面板打开后，折起来变成全屏展示
if (import.meta.env.VITE_USE_SIDE_PANEL === 'true') {
    useWindowResize(async() => {
        const navConfig = await getNavHeight();
        const statusBarH = navConfig.statusBarH;
        onUpdate({
            statusHeight: statusBarH,
        });
        storeCommon.headerHeight = +statusBarH + 52;
    });
}

const emit = defineEmits(['navClick', 'initFinish', 'share']);
watch(
    () => storeCommon.appMaxWidth,
    () => {
        onUpdate({
            maxWidth: `${Math.round(storeCommon.appMaxWidth)}`,
        });
    }
);
const onNavClick = (e: Record<string, any>) => {
    emit('navClick', e);
    if (props.isCloseWebiew && e.type === 'back') {
        closeWebview();
    }
    if (e.type === 'share') {
        emit('share');
    }
};

const onNavChange = async(data: Record<string, any>) => {
    if (data.type === 'animation') {
        setWebviewConfig({ status_bar: navigationConfig.value.styleConfig[data.value].statusBar, });
    }
};

if (storeCommon.systemInfo.inQmApp) {
    getStatusBarInfo();
}

defineExpose({
    onUpdate,
});

onMounted(() => {});
</script>

<style lang="scss" scoped></style>
